import BaseAPI from './BaseAPI';

// Lump payments from invoiced and hotel accounts, under /remittances.
class RemittancesAPI extends BaseAPI {
  constructor() { super('remittances'); }

  // POST /remittances { account, amount, receivedAt, note }
  record(payload) { return this.post('/', { body: payload }); }

  // GET /remittances/:id/proposal → oldest line first; writes nothing
  proposal(idRemittance) { return this.get(`/${idRemittance}/proposal`); }

  // POST /remittances/:id/allocate { allocations: [{ idPayment, amount }] }
  allocate(idRemittance, allocations) {
    return this.post(`/${idRemittance}/allocate`, { body: { allocations } });
  }
}

export const RemittancesService = new RemittancesAPI();
export default RemittancesAPI;
